import FilterConstants from '../../filter-constants';
import * as ToleranceUtils from './tolerance-utils';
import * as CommonUtils from '../../utils/common';

let capacitorToleranceIdeal = {
  name: FilterConstants.capacitorTolerance.ideal,
  nominalFactor: 10000000,
  allowedMin: FilterConstants.Limits.CSMALL_COMP_LIMIT,
  allowedMax: FilterConstants.Limits.CBIG_COMP_LIMIT,
  multiplicationFactors: [1],
};

let capacitorToleranceOnePercent = {
  name: FilterConstants.capacitorTolerance.one,
  nominalFactor: 10000000,
  allowedMin: FilterConstants.Limits.CSMALL_COMP_LIMIT,
  allowedMax: 0.0000000048,
  multiplicationFactors: [0.99, 1.0, 1.01],
};

let capacitorToleranceFivePercent = {
  name: FilterConstants.capacitorTolerance.five,
  nominalFactor: 10000000,
  allowedMin: FilterConstants.Limits.CSMALL_COMP_LIMIT,
  allowedMax: FilterConstants.Limits.CBIG_COMP_LIMIT,
  multiplicationFactors: [0.95, 0.97, 1.0, 1.03, 1.05],
};

let capacitorToleranceTenPercent = {
  name: FilterConstants.capacitorTolerance.ten,
  nominalFactor: 10000000,
  allowedMin: FilterConstants.Limits.CSMALL_COMP_LIMIT,
  allowedMax: FilterConstants.Limits.CBIG_COMP_LIMIT,
  multiplicationFactors: [0.9, 0.95, 1.0, 1.05, 1.1],
};

let capacitorToleranceTwentyPercent = {
  name: FilterConstants.capacitorTolerance.twenty,
  nominalFactor: 10000000,
  allowedMin: FilterConstants.Limits.CSMALL_COMP_LIMIT,
  allowedMax: FilterConstants.Limits.CBIG_COMP_LIMIT,
  multiplicationFactors: [0.8, 0.9, 1.0, 1.1, 1.2],
};

let capacitorToleranceConfigs = [
  capacitorToleranceIdeal,
  capacitorToleranceOnePercent,
  capacitorToleranceFivePercent,
  capacitorToleranceTenPercent,
  capacitorToleranceTwentyPercent,
];

// let supportedESeries = [
//   FilterConstants.eSeries.E6,
//   FilterConstants.eSeries.E12,
//   FilterConstants.eSeries.E24,
//   FilterConstants.eSeries.ideal,
// ];

// export function computeNominalValue(idealValue, toleranceInput, forceRoundDirection) {
//   let selectedSeries = toleranceInput.capacitorPreferredSeries;
//   let preferredSeries = getSeries(selectedSeries);
//   let nominalValue = ToleranceUtils.computeNominalValue(idealValue, preferredSeries, forceRoundDirection);

//   return nominalValue;
// }

export function getToleranceValues(value, selectedTolerance) {
  if (CommonUtils.isNullOrUndefined(value) || value === 0 || CommonUtils.isNearInfinity(value)) {
    return {
      isToleranceCoerced: false,
      finalTolerance: FilterConstants.capacitorTolerance.ideal,
      toleranceArray: [value],
    };
  }

  let toleranceConfig = ToleranceUtils.getToleranceConfig(capacitorToleranceConfigs, value, selectedTolerance);
  let isToleranceCoerced = toleranceConfig !== null;
  let finalTolerance = toleranceConfig.name;
  let toleranceArray = ToleranceUtils.getToleranceArray(value, toleranceConfig);
  return {
    isToleranceCoerced: isToleranceCoerced,
    finalTolerance: finalTolerance,
    toleranceArray: toleranceArray,
  };
}

// function getSeries(selectedSeries) {
//   var isSupported = supportedESeries.some((item) => item === selectedSeries);
//   if (!isSupported) throw `Series ${selectedSeries} is not supported. Supported series are ${supportedESeries}`;

//   return ToleranceUtils.getSeries(selectedSeries);
// }
